var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("PAGE_NEXTYEAR_POP_TITLE"),
        visible: "",
        width: "60%",
      },
      on: { close: _vm.onCancel },
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-width": "10px",
          },
        },
        [
          _c(
            "el-form-item",
            { staticClass: "error-right", attrs: { prop: "day" } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("ROLL_FOREARD_TASK_TEXT1")) +
                  "\n      "
              ),
              _c(
                "el-select",
                {
                  model: {
                    value: _vm.ruleForm.day,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "day", $$v)
                    },
                    expression: "ruleForm.day",
                  },
                },
                _vm._l(_vm.options, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("ROLL_FOREARD_TASK_TEXT2")) +
                  "\n    "
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { staticClass: "wl-grey", on: { click: _vm.onCancel } },
            [_vm._v(_vm._s(_vm.$t("comment_reSet")))]
          ),
          _c(
            "el-button",
            {
              staticClass: "wl-green",
              attrs: { type: "primary" },
              on: { click: _vm.onConfirm },
            },
            [_vm._v(_vm._s(_vm.$t("COMMON_ADD")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }